import { useCallback, useEffect, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

export default function useDashboardMapaCalor(
  endpoint,
  entidadeId,
  {
    consolidaAreasSubordinadas = true,
    enabled = true,
    filtros,
    page = 0,
    refreshToken = 0,
  } = {}
) {
  const [dados, setDados] = useState(null);
  const [endpointCarregado, setEndpointCarregado] = useState(null);
  const [entidadeIdCarregada, setEntidadeIdCarregada] = useState(null);
  const [consolidacaoCarregada, setConsolidacaoCarregada] = useState(null);
  const [paginaCarregada, setPaginaCarregada] = useState(null);
  const [filtrosCarregados, setFiltrosCarregados] = useState(null);
  const [erro, setErro] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [retryToken, setRetryToken] = useState(0);

  const carregarNivel = useCallback(
    async ({
      areaPaiId,
      page: requestedPage = 0,
      pageSize,
      reportError = true,
    } = {}) => {
      const params = {
        ...filtros,
        consolidaAreasSubordinadas,
        entidadeId,
        page: requestedPage,
      };

      if (areaPaiId != null) params.areaPaiId = areaPaiId;
      if (pageSize != null) params.pageSize = pageSize;

      try {
        const response = await http.get(endpoint, { params });

        return response.data;
      } catch (err) {
        if (reportError) errorHandler(err);
        throw err;
      }
    },
    [consolidaAreasSubordinadas, endpoint, entidadeId, filtros]
  );

  useEffect(() => {
    if (!enabled || !entidadeId) return undefined;

    let ativo = true;

    const carregarDados = async () => {
      setErro(false);
      setIsLoading(true);

      try {
        const response = await carregarNivel({ page, reportError: false });

        if (ativo) {
          setDados(response);
          setEndpointCarregado(endpoint);
          setConsolidacaoCarregada(consolidaAreasSubordinadas);
          setEntidadeIdCarregada(entidadeId);
          setFiltrosCarregados(filtros);
          setPaginaCarregada(page);
        }
      } catch (err) {
        if (ativo) {
          setErro(true);
          errorHandler(err);
        }
      } finally {
        if (ativo) {
          setIsLoading(false);
        }
      }
    };

    carregarDados();

    return () => {
      ativo = false;
    };
  }, [
    carregarNivel,
    consolidaAreasSubordinadas,
    enabled,
    endpoint,
    entidadeId,
    filtros,
    page,
    refreshToken,
    retryToken,
  ]);

  const retry = useCallback(() => setRetryToken((current) => current + 1), []);

  return {
    carregarNivel,
    dados:
      endpointCarregado === endpoint &&
      entidadeIdCarregada === entidadeId &&
      filtrosCarregados === filtros &&
      paginaCarregada === page &&
      consolidacaoCarregada === consolidaAreasSubordinadas
        ? dados
        : null,
    erro,
    isLoading,
    retry,
  };
}
